"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepperNavigation = void 0;
const theme_1 = require("@pulse-web-ui/theme");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StepperNavigation = styled_components_1.default.div `
  ${theme_1.mixins.flex({ justifyContent: 'space-between' })}
  width: 100%;

  & > * {
    flex: 1;
  }

  ${theme_1.media.desktop} {
    ${theme_1.mixins.flex({ gap: 16, justifyContent: 'flex-start' })}

    & > * {
      flex: initial;
    }
  }
`;
